export const enumPermisosGestionBCS = Object.freeze({
  GESTION_BCS: 36011,
  COMERCIOS_RECHAZADOS_BCS: 36012,
  CONVENIOS_BCS: 36014,
  COMERCIOS_CANCELADOS_BCS: 36017,
  CREACION_TERMINALES_BCS: 36018,
  CREACION_COMERCIOS_BCS: 36019,
});

